module.exports = __webpack_public_path__ + "static/logo_yonglin_footer-96e8ce99fd9031790222710c88959832.png";